<template>
  <div class="product-detail">
    <section class="page-header" v-if="product">
      <div class="container">
        <h1>{{ product.name }}</h1>
      </div>
    </section>

    <section class="product-video-section" v-if="product">
      <div class="container">
        <div class="video-container">
          <iframe 
            :src="product.videoUrl" 
            frameborder="0" 
            allowfullscreen
            class="product-video">
          </iframe>
        </div>
        
        <!-- 产品留言板块 -->
        <!--<div class="product-message-section">
          <div class="message-form">
            <h2>留言/评论</h2>
            <p>Message/Comment</p>
            <form @submit.prevent="submitMessage">
              <div class="form-group">
                <label for="name">联系人 *</label>
                <input 
                  type="text" 
                  id="name" 
                  v-model="messageForm.name" 
                  required 
                  placeholder="请输入您的姓名">
              </div>
              
              <div class="form-group">
                <label for="email">电子邮箱 *</label>
                <input 
                  type="email" 
                  id="email" 
                  v-model="messageForm.email" 
                  required 
                  placeholder="请输入您的邮箱地址">
              </div>
              
              <div class="form-group">
                <label for="content">留言内容 *</label>
                <textarea 
                  id="content" 
                  v-model="messageForm.content" 
                  required 
                  placeholder="请输入您的留言内容"
                  rows="6"></textarea>
              </div>
              
              <button type="submit" class="submit-btn" :disabled="isSubmitting">
                {{ isSubmitting ? '提交中...' : '提交留言' }}
              </button>
              
              <div v-if="submitMessageText" class="submit-message" :class="{ success: isSubmitSuccess, error: !isSubmitSuccess }">
                {{ submitMessageText }}
              </div>
            </form>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  data() {
    return {
      productId: this.$route.params.id,
      product: null,
      relatedProducts: [],
      messageForm: {
        name: '',
        email: '',
        content: ''
      },
      isSubmitting: false,
      submitMessageText: '',
      isSubmitSuccess: false
    }
  },
  methods: {
    getImageUrl(imagePath) {
      // 将相对路径转换为实际的图片URL
      const imageMap = {
        '@/assets/images/image1.jpg': require('@/assets/images/image1.jpg'),
        '@/assets/images/image2.jpg': require('@/assets/images/image2.jpg'),
        '@/assets/images/image3.jpg': require('@/assets/images/image3.jpg')
      };
      return imageMap[imagePath] || require('@/assets/images/image1.jpg');
    },
    loadProduct() {
      // 模拟产品数据加载
      const products = [
        {
          id: 1,
          name: '挤压丝锥加工',
          image: '@/assets/images/image1.jpg',
          videoUrl: 'https://v.qq.com/txp/iframe/player.html?vid=f3307pe9uuq',
          images: [
            '@/assets/images/image1.jpg',
            '@/assets/images/image2.jpg',
            '@/assets/images/image3.jpg'
          ],
          specifications: [
            { label: '材质', value: '高速钢' },
            { label: '规格', value: 'M3-M30' },
            { label: '表面处理', value: '氮化处理' },
            { label: '精度等级', value: 'H2' }
          ],
          detailedDescription: '挤压丝锥是一种通过塑性变形形成螺纹的刀具，适用于韧性较好的材料如铝合金、不锈钢等。我们的挤压丝锥采用优质高速钢材料制造，具有优异的耐磨性和使用寿命。',
          features: [
            '高精度螺纹加工',
            '减少切屑处理问题',
            '提高生产效率',
            '延长刀具使用寿命',
            '适用于自动化生产线'
          ]
        },
        {
          id: 2,
          name: '非标孔加工刀具',
          category: '刀具系列',
          image: '@/assets/images/image2.jpg',
          videoUrl: 'https://v.qq.com/txp/iframe/player.html?vid=f3307pe9uuq',
          images: [
            '@/assets/images/image2.jpg',
            '@/assets/images/image1.jpg',
            '@/assets/images/image3.jpg'
          ],
          specifications: [
            { label: '材质', value: '硬质合金' },
            { label: '直径范围', value: 'φ2-φ50mm' },
            { label: '加工深度', value: '可达10倍径' },
            { label: '冷却方式', value: '内冷/外冷' }
          ],
          detailedDescription: '非标孔加工刀具可根据客户具体需求定制，适用于各种特殊孔型加工。采用先进的硬质合金材料和涂层技术，确保在高强度材料加工中表现出色。',
          features: [
            '可根据客户需求定制',
            '适用于各种难加工材料',
            '高精度尺寸控制',
            '优异的排屑性能',
            '长寿命设计'
          ]
        }
      ];
      
      // 查找当前产品
      this.product = products.find(p => p.id == this.productId) || products[0];
      
      // 设置相关产品（排除当前产品）
      this.relatedProducts = products.filter(p => p.id != this.productId);
    },
    changeMainImage(imageUrl) {
      if (this.product) {
        this.product.image = imageUrl;
      }
    },
    contactUs() {
      alert('感谢您的关注！请联系我们的销售团队：020 39215900');
    },
    submitMessage() {
      this.isSubmitting = true;
      this.submitMessageText = '';
      this.isSubmitSuccess = false;

      // 模拟提交留言
      setTimeout(() => {
        this.isSubmitting = false;
        this.submitMessageText = '留言提交成功！';
        this.isSubmitSuccess = true;

        // 清空表单
        this.messageForm.name = '';
        this.messageForm.email = '';
        this.messageForm.content = '';
      }, 2000);
    }
  },
  mounted() {
    this.loadProduct();
  }
}
</script>

<style scoped>
.product-detail {
  margin-top: 80px;
}

.page-header {
  background: linear-gradient(to right,#0a338c,#0a338c);
  color: white;
  padding: 60px 0;
  text-align: center;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.product-video-section {
  padding: 80px 0;
  background-color: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
  margin-bottom: 50px;
}

.product-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* 产品留言板块样式 */
.product-message-section {
  padding: 40px 0;
  background-color: #f8f9fa;
  border-radius: 10px;
}

.message-form {
  max-width: 600px;
  margin: 0 auto;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.message-form h2 {
  margin-bottom: 30px;
  font-size: 1.8rem;
  color: #333;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: white;
  font-size: 1rem;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.submit-btn {
  width: 100%;
  padding: 15px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.submit-btn:hover:not(:disabled) {
  background: #66b1ff;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submit-message {
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
  text-align: center;
  font-weight: 500;
}

.submit-message.success {
  background: rgba(46, 204, 113, 0.2);
  border: 1px solid #2ecc71;
  color: #2ecc71;
}

.submit-message.error {
  background: rgba(231, 76, 60, 0.2);
  border: 1px solid #e74c3c;
  color: #e74c3c;
}

@media (max-width: 768px) {
  .product-detail {
    margin-top: 140px;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .page-header p {
    font-size: 1rem;
  }
  
  .product-video-section {
    padding: 50px 0;
  }
  
  .video-container {
    padding-bottom: 56.25%;
  }
  
  .product-message-section {
    padding: 30px 0;
  }
  
  .message-form {
    padding: 20px;
  }
  
  .message-form h2 {
    font-size: 1.5rem;
  }
}
</style>